"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.InteropMissingEventSourceError = exports.InteropResponseTimeoutError = exports.InteropUnrecognizedResponseError = exports.InteropResponseError = void 0;
var InteropResponseError = /** @class */ (function (_super) {
    __extends(InteropResponseError, _super);
    function InteropResponseError(response) {
        var _this = _super.call(this, "Error Response '" + response.id + "': " + response.body) || this;
        _this.name = "InteropResponseError";
        _this.response = response;
        return _this;
    }
    return InteropResponseError;
}(Error));
exports.InteropResponseError = InteropResponseError;
var InteropUnrecognizedResponseError = /** @class */ (function (_super) {
    __extends(InteropUnrecognizedResponseError, _super);
    function InteropUnrecognizedResponseError(response) {
        var _this = _super.call(this, "Unrecognized Response '" + response.id + "': " + response.body) || this;
        _this.name = "InteropUnrecognizedResponseError";
        _this.response = response;
        return _this;
    }
    return InteropUnrecognizedResponseError;
}(Error));
exports.InteropUnrecognizedResponseError = InteropUnrecognizedResponseError;
var InteropResponseTimeoutError = /** @class */ (function (_super) {
    __extends(InteropResponseTimeoutError, _super);
    function InteropResponseTimeoutError(id) {
        var _this = _super.call(this, "Request '" + id + "': Response timeout") || this;
        _this.name = "InteropResponseTimoutError";
        return _this;
    }
    return InteropResponseTimeoutError;
}(Error));
exports.InteropResponseTimeoutError = InteropResponseTimeoutError;
var InteropMissingEventSourceError = /** @class */ (function (_super) {
    __extends(InteropMissingEventSourceError, _super);
    function InteropMissingEventSourceError(request) {
        var _this = _super.call(this, "Request '" + request.id + "': Event source unknown. Unable to respond") || this;
        _this.name = "InteropMissingEventSourceError";
        return _this;
    }
    return InteropMissingEventSourceError;
}(Error));
exports.InteropMissingEventSourceError = InteropMissingEventSourceError;
//# sourceMappingURL=errors.js.map